export const NAMESPACE = 'patients';
